module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-bootstrap/~/babel-runtime/core-js/object/create.js
 ** module id = 330
 ** module chunks = 0
 **/